import { useState, useEffect } from 'react';
import { authService } from '../../services/api';
import { useNotification } from '../Notifications/NotificationContext';
import PushTip from '../UI/PushTip/PushTip';

export default function CfgModal({ open, bot, onClose, onImported }) {
    const { showError, showSuccess } = useNotification();
    const [newToken, setNewToken] = useState('');
    const [tokenLoading, setTokenLoading] = useState(false);

    useEffect(() => {
        if (!open) return;
        setNewToken('');
    }, [open]);

    if (!open) return null;

    const handleUpdateToken = async () => {
        if (!bot?.id) {
            showError('Bot inválido');
            return;
        }
        if (!newToken) {
            showError('Informe o novo token');
            return;
        }

        const warning = 'Ao alterar o token, mídias e áudios serão removidos e usuários marcados como bloqueados.\n' +
            'Se estiver renovando o token do mesmo bot, dados serão preservados.\n\n' +
            'Deseja continuar?';
        if (!window.confirm(warning)) return;

        try {
            setTokenLoading(true);
            const res = await authService.bots.update_token(bot.id, newToken);
            if (res.data?.success) {
                showSuccess(res.data?.message || 'Token atualizado com sucesso');
                setNewToken('');
                if (onImported) onImported();
                onClose();
            } else {
                showError(res.data?.error || 'Erro ao atualizar token');
            }
        } catch (err) {
            showError(err?.response?.data?.error || err?.message || 'Erro ao atualizar token');
        } finally {
            setTokenLoading(false);
        }
    };

    return (
        <div className="manage-bots-modal-overlay" onClick={onClose}>
            <div className="manage-bots-modal" onClick={(e) => e.stopPropagation()}>
                <div className="manage-bots-modal-header">
                    <h3>Atualizar Token</h3>
                    <button type="button" className="manage-bots-close" onClick={onClose}>&times;</button>
                </div>

                <input
                    className="input3 mt-4"
                    placeholder="Cole o novo token do bot"
                    value={newToken}
                    onChange={(e) => setNewToken(e.target.value)}
                />

                <PushTip>
                    Ao alterar o token, mídias e áudios serão removidos e usuários marcados como bloqueados.
                    Se estiver renovando o token do mesmo bot, dados serão preservados.
                </PushTip>

                <div className="manage-bots-footer mt-2" style={{ marginTop: 12 }}>
                    <div className="manage-bots-footer-actions">
                        <button type="button" className="btn-secondary" onClick={onClose} disabled={tokenLoading}>Cancelar</button>
                        <button type="button" className="btn-primary" onClick={handleUpdateToken} disabled={tokenLoading}>
                            {tokenLoading ? 'Atualizando...' : 'Atualizar Token'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
